import produce from 'immer';

import { errorMessageFromResponse } from '../../helpers/errors';
import { createReducer } from '../utils';

import { FETCH_CWE_LIST } from './actions';
import type { CWEStore } from './store';

const getInitialState = (): CWEStore => ({
  cwes: [],
  status: {
    loading: false,
    error: null,
  },
});

const cweReducer = createReducer(getInitialState(), {
  [`${FETCH_CWE_LIST}_PENDING`]: (state) => produce(state, draftState => {
    draftState.status.loading = true;
    draftState.status.error = null;
  }),
  [`${FETCH_CWE_LIST}_FULFILLED`]: (state, action) => produce(state, draftState => {
    draftState.cwes = action.payload.data;
    draftState.status.loading = false;
    draftState.status.error = null;
  }),
  [`${FETCH_CWE_LIST}_REJECTED`]: (state, action) => produce(state, draftState => {
    draftState.status.loading = false;
    draftState.status.error = errorMessageFromResponse(action.payload);
  }),
});

export default cweReducer;
